import React from 'react'

const IconTextTool = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M5 5h14' />
         <path d='M12 5v14' />
      </svg>
   )
}
export default IconTextTool
